import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class UXContent extends Component {
    static propTypes = {
        content: PropTypes.object
    };

    render() {
        const {content} = this.props;
        return (
            <div className="block-content">
                <h2>{content.title}</h2>
                <p dangerouslySetInnerHTML={{__html: content.content}} />
            </div>
        );
    }
}
